module.exports = __webpack_public_path__ + "static/media/other_work_request.54992862.svg";